import { Pipe, PipeTransform } from '@angular/core';
import { Timestamp } from '@angular/fire/firestore';
import dayjs from 'dayjs';

@Pipe({ name: 'isExpired', standalone: true, pure: true })
export class IsExpiredPipe implements PipeTransform {
  transform(date: Timestamp | undefined): boolean {
    if (!date) return false;
    return dayjs().isAfter(dayjs(date.toDate()));
  }
}
